import classNames from "classnames";
import { useContext, useMemo, useState } from "react";
import { ObjectSchema, boolean, mixed, number, object, string } from "yup";
import { AvisConstants } from "../../../data/avisConstants";
import {
  PublicMusicalCreationInfo,
  PublicMusicalCreationListFilter,
} from "../../../generated/data-contracts";
import { FilterType } from "../../../models";
import { IAxiosError, TableUtils, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import {
  AvisDataRenewDate,
  AvisDescriptiveText,
} from "../../shared/components/form";
import {
  AvisFilterableTable,
  IColumnConfig,
} from "../../shared/components/table";
import { AvisContext } from "../../shared/context/AvisContext";
import { PublicCreationsFilterForm } from "../components/filters/PublicCreationsFilterForm";

export function PublicCreationsView() {
  const { res } = useContext(AvisContext);

  const [error, setError] = useState<IAxiosError>();
  const defaultFilterValues: PublicMusicalCreationListFilter = {
    creationName: "",
    creationNameFilterType: "Contains",
    rightsHolderNameOrIpiNumber: "",
    rightsHolderNameOrIpiNumberFilterType: "Contains",
    searchAllNames: false,
    pageIndex: 0,
    pageSize: AvisConstants.default_table_page_size,
  };

  const validationSchema: ObjectSchema<PublicMusicalCreationListFilter> =
    object({
      creationName: string(),
      creationNameFilterType: mixed<FilterType>(),
      rightsHolderNameOrIpiNumber: string(),
      rightsHolderNameOrIpiNumberFilterType: mixed<FilterType>(),
      searchAllNames: boolean(),
      pageIndex: number().min(0),
      pageSize: number().min(1),
    });

  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      TableUtils.columnConfigStringHTMLEnabled<PublicMusicalCreationInfo>(
        "creationNameToDisplay",
        res("label_CreationName"),
      ),
      TableUtils.columnConfigStringHTMLEnabled<PublicMusicalCreationInfo>(
        "rightsHolderNamesToDisplay",
        res("public_MusicalCreations_RightsHolders"),
      ),
      TableUtils.columnConfigStringHTMLEnabled<PublicMusicalCreationInfo>(
        "bandsToDisplay",
        res("public_MusicalCreations_AdditionalInfo"),
      ),
    ];
  }, [res]);
  const renderContent = (
    <>
      <AvisDescriptiveText textKey={"portal_PUBL_MusicCreations"} />
      <AvisDataRenewDate dataType="publicMusicalCreationsUpdateDate" />
      <AvisFilterableTable<
        PublicMusicalCreationInfo,
        PublicMusicalCreationListFilter
      >
        defaultFilterValues={defaultFilterValues}
        filterValidationSchema={validationSchema}
        setError={setError}
        getApiData={(filter) =>
          api.publicGetPublicMusicalCreations(filter as any)
        }
        loadDataOnInit={false}
        renderFilter={(bag, loading, filtered) => (
          <PublicCreationsFilterForm
            bag={bag}
            loading={loading}
            filtered={filtered}
          />
        )}
        tableColumns={columnMetadata}
      />
    </>
  );

  const classNameForm = classNames(
    "avis-public-container",
    "public-blank-media",
  );

  return (
    <AvisForm
      title={res("public_MusicalCreations_Title")}
      error={error}
      className={classNameForm}
    >
      {renderContent}
    </AvisForm>
  );
}
